import {
  useMaterialsClassificationMetadata as useDomainClassificationMetadata,
  MaterialType,
  ClassificationMetadataResponse,
  ClassificationMetadataEntry
} from '@domain/materials'

export const useMaterialsClassificationMetadata = <T extends MaterialType>(materialType: T) => {
  return useDomainClassificationMetadata({
    options: {
      select: (data: ClassificationMetadataResponse): ClassificationMetadataEntry<T> => {
        const metadataForMaterial = data.metadata.find(
          (matadata) => matadata.materialType === materialType
        )
        if (!metadataForMaterial) {
          throw new Error(`Metadata for material type ${materialType} not found`)
        }
        return metadataForMaterial as ClassificationMetadataEntry<T>
      }
    }
  })
}
